import queryString from 'query-string'
import {
  ObterRegistrosAuditoriaFiltro,
  RegistrosAuditoriaResposta,
  TipoEntidadeAuditoria
} from 'src/dto'

import { gatewayApi } from '../instancias-api'

const urlBase = '/Auditoria'

export const ObterRegistrosAuditoria = async (
  tipoEntidade: TipoEntidadeAuditoria,
  entidadeId: string,
  filtro: ObterRegistrosAuditoriaFiltro = {}
): Promise<RegistrosAuditoriaResposta> => {
  const queryParams = queryString.stringify({
    categoria: filtro.categoria,
    cursor: filtro.cursor,
    tamanho: filtro.tamanho
  })

  const rota = `${urlBase}/${tipoEntidade}/${entidadeId}${
    queryParams ? `?${queryParams}` : ''
  }`
  const resposta = await gatewayApi.get<RegistrosAuditoriaResposta>(rota)

  return resposta.data
}
